(function () {
  'use strict';

  if (window.BISSBackorderTurbo && window.BISSBackorderTurbo.refresh) {
    window.BISSBackorderTurbo.refresh();
    return;
  }

  var formStates = new WeakMap();
  var propertyNames = {
    message: 'properties[Backorder]'
  };

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function setDisplay(element, value) {
    if (element && element.style.display !== value) {
      element.style.display = value;
    }
  }

  function setDisabled(button, disabled) {
    if (!button) return;

    if (button.disabled !== disabled) {
      button.disabled = disabled;
    }

    button.classList.toggle('disabled', disabled);
    var ariaDisabled = disabled ? 'true' : 'false';
    if (button.getAttribute('aria-disabled') !== ariaDisabled) {
      button.setAttribute('aria-disabled', ariaDisabled);
    }
  }

  function removeBackorderProperties(shopifyForm) {
    shopifyForm.querySelectorAll('[data-biss-backorder-property]').forEach(function (input) {
      input.remove();
    });
  }

  function addBackorderProperty(shopifyForm, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-biss-backorder-property', '');
    shopifyForm.appendChild(input);
  }

  function findNotifyForm(productForm) {
    var productId = productForm.getAttribute('data-product-id');
    var scope = productForm.closest('.product_section, .product-wrap, .thumbnail, [data-product-root]');
    var selector = '.notify-form-' + productId;
    return (scope && scope.querySelector(selector)) || document.querySelector(selector);
  }

  function selectedVariantId(productForm) {
    var variantInput = productForm.querySelector('[name="id"]');
    return variantInput ? String(variantInput.value) : '';
  }

  function currentState(productForm, state) {
    return state.variants.get(selectedVariantId(productForm));
  }

  function applyNativeState(productForm, state) {
    removeBackorderProperties(state.shopifyForm);
    productForm.removeAttribute('data-biss-purchase-state');
    setDisplay(state.acceleratedCheckout, '');

    if (state.notice) {
      state.notice.hidden = true;
      setText(state.notice, '');
    }
  }

  function applyBackorderState(productForm, state, variantState) {
    removeBackorderProperties(state.shopifyForm);
    addBackorderProperty(state.shopifyForm, propertyNames.message, variantState.message);

    productForm.setAttribute('data-biss-purchase-state', 'backorder');
    state.purchaseButtons && state.purchaseButtons.classList.remove('product-is-unavailable');
    setDisabled(state.button, false);
    setText(state.buttonText, state.button.getAttribute('data-biss-backorder-label') || 'Backorder Now');
    setDisplay(state.acceleratedCheckout, 'none');
    setDisplay(findNotifyForm(productForm), 'none');

    if (state.notice) {
      state.notice.hidden = false;
      setText(state.notice, 'Backorder: ' + variantState.message);
    }
  }

  function applySoldOutState(productForm, state) {
    removeBackorderProperties(state.shopifyForm);
    productForm.setAttribute('data-biss-purchase-state', 'sold_out');
    state.purchaseButtons && state.purchaseButtons.classList.add('product-is-unavailable');
    setDisabled(state.button, true);
    setText(state.buttonText, state.button.getAttribute('data-biss-sold-out-label') || 'Sold out');
    setDisplay(state.acceleratedCheckout, 'none');
    setDisplay(findNotifyForm(productForm), 'none');

    if (state.notice) {
      state.notice.hidden = true;
      setText(state.notice, '');
    }
  }

  function enforce(productForm) {
    var state = formStates.get(productForm);
    if (!state || state.enforcing) return;

    state.enforcing = true;
    try {
      var variantState = currentState(productForm, state);

      if (!variantState) {
        if (productForm.getAttribute('data-biss-has-owned-variants') === 'true') {
          applySoldOutState(productForm, state);
        } else {
          applyNativeState(productForm, state);
        }
        return;
      }

      if (variantState.owner !== 'boc') {
        applyNativeState(productForm, state);
      } else if (variantState.state === 'backorder') {
        applyBackorderState(productForm, state, variantState);
      } else if (variantState.state === 'sold_out') {
        applySoldOutState(productForm, state);
      } else {
        applyNativeState(productForm, state);
        productForm.setAttribute('data-biss-purchase-state', 'in_stock');
      }
    } finally {
      state.enforcing = false;
    }
  }

  function scheduleEnforce(productForm, delay) {
    window.setTimeout(function () {
      enforce(productForm);
    }, delay || 0);
  }

  function validateBackorderProperties(productForm, state, variantState) {
    var expected = [
      [propertyNames.message, variantState.message]
    ];

    return expected.every(function (entry) {
      var input = state.shopifyForm.querySelector('[name="' + entry[0] + '"]');
      return input && input.value === entry[1] && entry[1] !== '';
    });
  }

  function initialize(productForm) {
    if (formStates.has(productForm)) return;

    var script = productForm.querySelector('[data-biss-variant-states]');
    var shopifyForm = productForm.querySelector('form[action*="/cart/add"]');
    var button = productForm.querySelector('.add_to_cart');
    if (!script || !shopifyForm || !button) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (error) {
      variants = [];
      console.error('BISS backorder state data could not be parsed.', error);
    }

    var state = {
      variants: new Map(variants.map(function (variantState) {
        return [String(variantState.id), variantState];
      })),
      shopifyForm: shopifyForm,
      button: button,
      buttonText: button.querySelector('.text'),
      acceleratedCheckout: productForm.querySelector('[data-biss-accelerated-checkout]'),
      notice: productForm.querySelector('[data-biss-backorder-notice]'),
      purchaseButtons: productForm.querySelector('.purchase-details__buttons'),
      enforcing: false
    };

    formStates.set(productForm, state);

    productForm.addEventListener('change', function (event) {
      if (event.target.matches('[name="id"], input[type="radio"], select')) {
        scheduleEnforce(productForm, 0);
        scheduleEnforce(productForm, 75);
      }
    }, true);

    button.addEventListener('click', function (event) {
      enforce(productForm);
      var variantState = currentState(productForm, state);

      if (variantState && variantState.owner === 'boc') {
        if (variantState.state === 'sold_out') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (variantState.state === 'backorder' && !validateBackorderProperties(productForm, state, variantState)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          enforce(productForm);
          console.error('BISS blocked a backorder add because its line properties were incomplete.');
          return;
        }
      }

      scheduleEnforce(productForm, 1200);
      scheduleEnforce(productForm, 4000);
    }, true);

    shopifyForm.addEventListener('submit', function (event) {
      enforce(productForm);
      var variantState = currentState(productForm, state);
      if (!variantState || variantState.owner !== 'boc') return;

      if (variantState.state === 'sold_out' ||
          (variantState.state === 'backorder' && !validateBackorderProperties(productForm, state, variantState))) {
        event.preventDefault();
        event.stopImmediatePropagation();
        enforce(productForm);
      }
    }, true);

    var observer = new MutationObserver(function () {
      scheduleEnforce(productForm, 0);
    });
    observer.observe(button, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
      childList: true,
      subtree: true
    });

    enforce(productForm);
  }

  function refresh(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-product-form]')) {
      initialize(scope);
    }
    scope.querySelectorAll && scope.querySelectorAll('[data-product-form]').forEach(initialize);
  }

  var documentObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) refresh(node);
      });
    });
  });

  window.BISSBackorderTurbo = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refresh();
      documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    });
  } else {
    refresh();
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
}());
